{
  "en": {
    "client": {
      "actions": {
        "changeBackgroundImage": "Change Login Image",
        "new": "New Client",
        "setAsPrimary": "Set as primary",
        "submit": "Submit",
        "undoChanges": "Undo changes"
      },
      "attributes": {
        "address": "Address",
        "aftercare_conversation_enabled": "Aftercare conversations",
        "backgroundImage": "Login screen image",
        "email_address": "Email",
        "email_address_invoicing": "Invoicing Email",
        "email_address_renewal": "Contract renewal reminder email",
        "email_address_reply_to": "\"Reply-to\" Email Address",
        "email_address_ziggu": "\"From\" Email Address",
        "iban": "IBAN",
        "language": "Language",
        "languages": "Organisation Languages",
        "name": "Name",
        "phone": "Phone",
        "storage_sum": "Storage usage",
        "storage_sum_max": "{percentage}% of {gigabytes} GB",
        "subdomain": "Subdomain",
        "timezone": "Timezone",
        "vat_number": "VAT number"
      },
      "client_types": {
        "architects_designers": "Architects & Designers",
        "creative_agencies": "Creative Agencies",
        "general_specialized_contractors": "General & Specialized Contractors",
        "makers_manufacturers": "Makers & Manufacturers",
        "planners_coordinators": "Planners & Coordinators",
        "property_developers": "Property Developers"
      },
      "integrations": {
        "api_docs_info": "For more information about our API, please visit our",
        "api_documentation": "API documentation"
      },
      "labels": {
        "activeProjects": "Active projects",
        "activeProjectsUsed": "{0} projects active, {1} not used yet",
        "activeUnits": "Active units",
        "activeUnitsUsed": "{0} units active, {1} not used yet",
        "after_care_categories": "Categories",
        "after_care_statuses": "Statuses",
        "aftercare": "Aftercare",
        "bookADemo": "Book a demo",
        "by": "By {client}",
        "categories": "Categories",
        "category": "Category",
        "chatWithUs": "Chat with us",
        "companyProfile": "Organisation profile",
        "contactIntercom": "Contact us via the chat if you would like to change this.",
        "contactZiggu": "Got a question for Ziggu? Stuck with something? Product advice? Let's chat!",
        "conversations": "Conversations",
        "dashboard": "Dashboard",
        "decisions": "Decisions",
        "default_payment_overdue": "You have an overdue invoice for Ziggu. Please pay it immediately to avoid interest. Any questions? Do not hesitate to contact us.",
        "delete_category": "Delete {category} category?",
        "delete_category_expl": "Deleting document category cannot be undone. Existing documents with this category will be changed to category Other",
        "document_categories": "Categories",
        "documents": "Documents",
        "email_address_invoicing_info": "We will send new invoices to this address.",
        "email_address_renewal_info": "We will send emails to address when your subscription renewal date is coming up and we would like to inform you about it together with all the necessary information.",
        "email_address_reply_to": "This email address will be used if anybody replies to an email sent via {email_address_ziggu}. Contact us via the chat if you would like to change this.",
        "email_address_ziggu": "This email address will be used as the FROM address of all emails sent via the platform (emails regarding notifications, invitations, password resets, ...)",
        "email_forwarder_must_be_owner": "Only team members with the role 'Owner' can forward emails.",
        "email_forwarding_activated": "Email forwarding is active",
        "email_forwarding_activated_project": "Project email forwarding is active",
        "email_forwarding_disclaimer": "To prevent spam, only emails sent from an address linked to an <b>existing Owner/Maintainer Profile</b> are processed.<br>Emails from unknown senders will be ignored.",
        "email_forwarding_is": "Your forwarding address is",
        "financials": "Financials",
        "general": "General",
        "goToSettings": "Settings",
        "helpcenter": "Help center",
        "inbound_email": "Inbound email",
        "invoice_overdue": "You have one late payment. Please contact accounting{'@'}ziggu.io for further information.",
        "invoice_overdue_title": "Invoice overdue",
        "language": "This is the organisation's default language for your login page, customers and team members.",
        "languages": "The primary language is the default for content entry and cannot be removed. Add additional languages to support multilingual content. Click any additional language to make it the primary.",
        "mobile_app_disabled": "Mobile app (PWA) not active",
        "mobile_app_enabled": "Mobile app (PWA) active",
        "mobile_app_info": "Message us on Intercom for more information!",
        "mustBeJPG": "Must be a .jpg image",
        "new_categories": "Extra categories",
        "new_document_category": "Category",
        "noCategories": "You don't have any categories yet. Create one to get started.",
        "other": "Other",
        "outOfOffice": "Out of office",
        "outOfOfficeMessage": "Out of office message (optional)",
        "packageUnits": "Subscribed for",
        "primary": "Primary",
        "removed_user": "Removed user",
        "settings": {
          "click_to_copy": "Click to copy token to clipboard",
          "copied_to_clipboard": "Token copied to clipboard"
        },
        "snippets": "Snippets",
        "subscription": "Subscription",
        "subscriptionRenewalDate": "Renewal date",
        "subscriptionUsageUnits": "Current usage",
        "tab_aftercare": "Aftercare",
        "tab_billing": "Billing",
        "tab_branding": "Branding",
        "tab_features": "Features",
        "tab_general": "General",
        "tab_information": "Information",
        "tab_integrations": "Integrations",
        "tickets": "Conversations",
        "timezone": "This is the organisation's default timezone.",
        "translation_not_added_yet": "Translation is not added yet",
        "unchangeable_categories": "Default categories which are unchangeable",
        "unchangeable_categories_info": "These categories are needed for the system to function properly or are being used in integrations.",
        "upgradePackageContactUs": "Contact us to get started",
        "upgradePackageSubtitleAftercare": "This feature will enable you to follow up with customers after delivery and help them resolve any issues with their new home",
        "upgradePackageSubtitleConversationMentions": "This feature will enable you to write private notes and tag team members in a conversation",
        "upgradePackageSubtitleFinancials": "Create a financial overview for every buyer in an instant",
        "upgradePackageSubtitleMilestones": "This feature allows you to communicate the construction progress in an easy way to your customer",
        "upgradePackageSubtitleMultipleCustomerSingleUnit": "This feature will enable you to invite a second homebuyer to the Ziggu platform",
        "upgradePackageTitle": "Looks like you don't have this feature yet",
        "warningooo": "OOO active",
        "yourEmail": "Your email",
        "zigguHome": "Ziggu Home"
      },
      "project_types": {
        "mup": "MUPs",
        "mup_and_sup": "MUPs and SUPs",
        "sup": "SUPs"
      },
      "toasts": {
        "attachment_category": {
          "create": "Document category created",
          "update": "Document category has been updated"
        }
      },
      "validation": {
        "attachment_category_required": "Category is required",
        "duplicated_translation": "Duplicated translation",
        "mustBeEmailAddress": "Must be an Email address",
        "needName": "Name is required"
      }
    }
  }
}
